import produce, { original } from 'immer';

import * as actionTypes from '../../actions/actionTypes';

export const initialState = {
  byId: {},
  loading: false,
  error: null,
  instances: {
    loading: false,
    byId: {},
    error: null,
    selected: null
  }
};

const reducer = produce(
  (state, action) => {
    switch (action.type) {
      case actionTypes.SET_PROPERTY:
        const storeProperty = state.byId[action.property.propertyId];
        if (storeProperty === undefined || action.property.updatedAt > storeProperty.updatedAt) {
          const formattedProperty = _formatProperty(action.property);
          state.byId[formattedProperty.propertyId] = formattedProperty;
          if (formattedProperty.instanceId) {
            if (state.instances.byId[formattedProperty.instanceId] === undefined) {
              state.instances.byId[formattedProperty.instanceId] = {
                instanceId: formattedProperty.instanceId,
                propertyId: formattedProperty.propertyId,
                createdAt: formattedProperty.instancedAt,
                active: true,
                lastVisited: null,
                propertyEvents: {
                  byId: {}
                }
              };
            }
          } else {
            // Incoming property data is used to determine if a client has resolved an instance.
            if (
              storeProperty !== undefined
                && storeProperty.instanceId
                && state.instances.byId[storeProperty.instanceId]
            ) {
              state.instances.byId[storeProperty.instanceId].active = false;
            }
          }
        }
        return;
      case actionTypes.SET_PROPERTIES:
        for (const incomingProperty of action.properties) {
          const storeProperty = state.byId[incomingProperty.propertyId];
          if (storeProperty === undefined || incomingProperty.updatedAt >= storeProperty.updatedAt) {
            const formattedProperty = _formatProperty(incomingProperty);
            state.byId[formattedProperty.propertyId] = formattedProperty;
            if (formattedProperty.instanceId) {
              if (state.instances.byId[formattedProperty.instanceId] === undefined) {
                state.instances.byId[formattedProperty.instanceId] = {
                  instanceId: formattedProperty.instanceId,
                  propertyId: formattedProperty.propertyId,
                  createdAt: formattedProperty.instancedAt,
                  active: true,
                  lastVisited: null,
                  propertyEvents: {
                    byId: {}
                  }
                }
              }
            } else {
              if (
                storeProperty !== undefined
                  && storeProperty.instanceId
                  && state.instances.byId[storeProperty.instanceId]
              ) {
                state.instances.byId[storeProperty.instanceId].active = false;
              }
            }
          }
        }
        return;
      case actionTypes.SET_PROPERTY_EVENT:
        if (state.instances.byId[action.propertyEvent.instanceId]) {
          state.instances.byId[action.propertyEvent.instanceId].propertyEvents.byId[action.propertyEvent.eventId] =
            action.propertyEvent;
          state.instances.byId[action.propertyEvent.instanceId].lastVisited =
            action.propertyEvent.instanceId
              ? action.propertyEvent.createdAt
              : state.instances.byId[action.propertyEvent.instanceId].lastVisited;
        } else {
          state.instances.byId[action.propertyEvent.instanceId] = {
            instanceId: action.propertyEvent.instanceId,
            propertyId: action.propertyEvent.propertyId,
            createdAt: action.propertyEvent.createdAt,
            active: true,
            lastVisited: null,
            propertyEvents: {
              byId: {
                [action.propertyEvent.eventId]: action.propertyEvent
              }
            }
          };
        }
        return;
      case actionTypes.SET_PROPERTY_EVENTS:
        if (Array.isArray(action.propertyEvents) && action.propertyEvents.length > 0) {
          state.instances.byId[action.propertyEvents[0].instanceId].propertyEvents.byId =
            action.propertyEvents.reverse().reduce((accumulator, propertyEvent) => ({
              ...accumulator,
              [propertyEvent.eventId]: propertyEvent
            }), {});
        }
        return;
      case actionTypes.RESOLVE_INSTANCE_LOADING:
        state.loading = true;
        state.error = null;
        return;
      case actionTypes.RESOLVE_INSTANCE_SUCCESS:
        state.loading = false;
        return;
      case actionTypes.RESOLVE_INSTANCE_ERROR:
        state.loading = false;
        state.error = action.error;
        return;
      case actionTypes.SET_SELECTED_INSTANCE:
        if (action.instanceId) {
          state.instances.selected = action.instanceId;
          state.instances.byId[action.instanceId].lastVisited = action.timestamp;
        } else {
          state.instances.selected = action.instanceId;
        }
        return;
      default:
        return;
    }
  },
  initialState
);

export default reducer;

export const _formatProperty = (property) => {
  const formattedProperty = { ...property };
  formattedProperty.isDeleted = property.isDeleted ? true : false;
  formattedProperty.variant = property.variant ? property.variant : null;
  return formattedProperty;
};